import * as React from 'react';

export default function Copy({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 21 20'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Document duplicate">
        <g id="Icon">
          <path
            d="M9.5 2C8.39543 2 7.5 2.89543 7.5 4V12C7.5 13.1046 8.39543 14 9.5 14H15.5C16.6046 14 17.5 13.1046 17.5 12V6.41421C17.5 5.88378 17.2893 5.37507 16.9142 5L14.5 2.58579C14.1249 2.21071 13.6162 2 13.0858 2H9.5Z"
            fill="currentColor"
          />
          <path
            d="M3.5 8C3.5 6.89543 4.39543 6 5.5 6V16H13.5C13.5 17.1046 12.6046 18 11.5 18H5.5C4.39543 18 3.5 17.1046 3.5 16V8Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
}
